
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-edit-delete-btns',
    templateUrl: './edit-delete-btns.component.html',
    styleUrls: ['./edit-delete-btns.component.scss'],
    standalone: true,
    imports: [TooltipModule]
})
export class EditDeleteBtnsComponent implements ICellRendererAngularComp {
  params: any;
  editButtonsVisible = true;
  deleteButtonsNotVisible = false;
  item_name: string = 'something'

  constructor(public sharedService: SharedService) { }

  agInit(params: any): void {
    this.params = params;
  }
  refresh(params?: any): boolean {
    return true;
  }

  // Button functions
  editItemClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.editItem(rowData);
  }
  deleteItemClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.deleteItem(rowData);
  }
}
